import { enumSnackbarStatusType } from "../../types/enums";

export interface FilterFields {
  installmentFilters: any;
}

export const initialState: FilterFields = {
  installmentFilters: {
    country: null,
    name: null,
    applicationScopeType: [],
    status: null,
  }
};

export interface IInstallmentData {
  country: number;
  cardType: number;
  numberOfInstallment: number[];
  status: number;
}

export interface ISelectItem {
  id: number;
  name: string;
}

export interface ISnackbarProps{
  show: boolean,
  message: string,
  status: enumSnackbarStatusType,
  autoHideDuration: number
}

export interface IConfirmationProps {
  open?: boolean,
  title?: string;
  content: string;
  acceptButtonName: string;
  acceptClick?: any;
  rejectButtonName: string;
  rejectClick?: any;
}

export class InstallmentOptionManagement {
  id: number;
  status: number;
  region: number;
  bank: number;
  numberOfInstallments: number[];

  constructor(
    id: number,
    status: number,
    region: number,
    bank: number,
    numberOfInstallments: number[]
  ) {
    this.id = id;
    this.status = status;
    this.region = region;
    this.bank = bank;
    this.numberOfInstallments = numberOfInstallments;
  }
}
